import { IAction, IActionBase } from "../types"

export const SET_ALGORITHM = "SET_ALGORITHM"

const initialState = "bubbleSort"

export default function algorithm(state = initialState, action: IActionBase): string {
    switch (action.type) {
        case SET_ALGORITHM:
            return (action as IAction<string>).payload
        default:
            return state
    }
}
